import "./styles.less";

import { Button } from "antd";
import QRCode from "qrcode.react";
import React from "react";

import facebookIcon from "../../../assets/facebook-icon.svg";
import instagramIcon from "../../../assets/instagram-icon.svg";
import starAtlasInstructionIcon from "../../../assets/star-atlas-instruction-icon.svg";
import starAtlasSoundOffIcon from "../../../assets/star-atlas-sound-off-icon.svg";
import starAtlasSoundOnIcon from "../../../assets/star-atlas-sound-on-icon.svg";
import { useLanguageContext } from "../../../contexts/language/language";

interface IStarAtlasPageProps {
  qrFacebook: string;
  qrInstagram: string;
  onClickEvent: () => void;
}

export const StarAtlasInstructionModal: React.FC<IStarAtlasPageProps> = ({ qrFacebook, qrInstagram, onClickEvent }) => {
  const {
    currentLanguageData: {
      pages: {
        dashboard: {
          modules: {
            nftModule: { starAtlas: starAtlasText },
          },
        },
      },
    },
  } = useLanguageContext();

  return (
    <div className="star-atlas-instruction-modal">
      <h3>{starAtlasText.instructions.arInstructionsTitle}</h3>
      <p>{starAtlasText.instructions.posterDescription}</p>
      <div className="star-atlas-instruction-modal__qr-wrapper">
        <div>
          <QRCode includeMargin={true} size={212} value={qrInstagram} />
          <p>
            <img src={instagramIcon} alt="instagram-icon" />
            <span>Instagram</span>
          </p>
        </div>
        <div>
          <QRCode includeMargin={true} size={212} value={qrFacebook} />
          <p>
            <img src={facebookIcon} alt="facebook-icon" />
            <span>Facebook</span>
          </p>
        </div>
      </div>
      <ol>
        <li>{starAtlasText.instructions.scanQR}</li>
        <li>{starAtlasText.instructions.chooseIGorFB}</li>
        <li>{starAtlasText.instructions.pressContinue}</li>
      </ol>
      <div className="star-atlas-instruction-modal__continue-button">
        <Button onClick={onClickEvent} type="primary">
          {starAtlasText.instructions.continueButton}
        </Button>
      </div>
    </div>
  );
};

interface IStarAtlasToolbarButtonsProps {
  instructionsButtonClickEvent: () => void;
  soundButtonClickEvent: () => void;
  soundPlaying: boolean;
}

export const StarAtlasToolbarButtons: React.FC<IStarAtlasToolbarButtonsProps> = ({
  instructionsButtonClickEvent,
  soundButtonClickEvent,
  soundPlaying,
}) => {
  const {
    currentLanguageData: {
      pages: {
        dashboard: {
          modules: {
            nftModule: { starAtlas: starAtlasText },
          },
        },
      },
    },
  } = useLanguageContext();
  return (
    <div className="star-atlas-toolbar-buttons">
      <Button
        icon={<img src={starAtlasInstructionIcon} alt="nft-instruction-icon" />}
        onClick={instructionsButtonClickEvent}
      >
        {starAtlasText.instructions.title}
      </Button>
      <Button
        icon={<img src={soundPlaying ? starAtlasSoundOffIcon : starAtlasSoundOnIcon} alt="nft-toggle-sound-icon" />}
        onClick={soundButtonClickEvent}
      >
        {starAtlasText.soundButton} {soundPlaying ? starAtlasText.off : starAtlasText.on}
      </Button>
    </div>
  );
};
